export const DISABLED_CONCLUSION_TOOLTIP =
  "Outstanding escalations must be resolved before the reviewer conclusion can be selected.";

export const WAIVER_REQUIRED_TOOLTIP =
  "Waiver document must be uploaded before resolution can be selected";

export const ESCALATION_REQUIRED_TOOLTIP =
  "You must create an escalation before you can select this resolution. Hover on a profile name cell to view the 'create escalation' option.";
